module.exports = __webpack_public_path__ + "66c684257d6e3565dcd691ff21296573.jpg";